let LRMap = false;

var activeMarker = false;

var mapType = false;

document.addEventListener("DOMContentLoaded", function() {

	var installersSearch =  document.getElementById('installersSearch');

	//if map is on page
	if (installersSearch) {

		document.addEventListener('click', function (event) {

			// If the clicked element doesn't have the right selector, bail
			if (!event.target.matches('#postcode-search-button')) return;
		
			document.getElementById('installersSearch').submit();
		
		}, false);
		if (document.location.href.indexOf('wp-admin') === -1){ 

			//variables sent from php
			var bottomBgColour = installersSearch.getAttribute('data-bottombgcolour');
			var linkTextColour = installersSearch.getAttribute('data-linktextcolour');
			var titleShade = installersSearch.getAttribute('data-titleshade');
			var linkBodyTextColour = installersSearch.getAttribute('data-bodytextcolour');


			if (typeof(installersSearch) != 'undefined' && installersSearch != null) {

				let origin = document.getElementById("origin");

				/**
				Enable Search by Postcode button if postcode input has a value
				*/
				if ( origin ) {

					document.getElementById("origin").addEventListener("keyup", function() {
						var nameInput = document.getElementById('origin').value;
						
						if (nameInput != "") {
							document.getElementById('postcode-search').removeAttribute("disabled");
						} else {
							document.getElementById('postcode-search').setAttribute("disabled", null);
						}
					});
				}

				let installersMap = document.getElementById("installersMap");

				let defaultColour = installersSearch.style.backgroundColor;

				if (installersMap) {

					let installersMap = document.getElementById('installersMap'), lat, lng;

					if ( installersMap && installersMap.getAttribute('data-lat')) {
						lat = parseFloat(document.getElementById('installersMap').getAttribute('data-lat'));
					} else if (branches_script_vars.latitude) {
						lat = parseFloat(branches_script_vars.latitude); 
					} else {
						lat = 51.5072;
					}

					if ( installersMap && installersMap.getAttribute('data-lng')) {
						lng = parseFloat(document.getElementById('installersMap').getAttribute('data-lng'));
					} else if (branches_script_vars.longitude) {
						lng = parseFloat(branches_script_vars.longitude ); 
					} else {
						lng = 0.1276;
					}

					let LRzoom = document.getElementById("zoomlevel");

					LRMap = new google.maps.Map(document.getElementById("installersMap"), {
						center: { 
							lat: lat,
							lng: lng
						},
						zoom: LRzoom && LRzoom.value ? parseInt(document.getElementById("zoomlevel").value) : 6.5,
						mapTypeControl: true,
						mapTypeControl: false,
						streetViewControl: false,
						minZoom: 1,
						mapTypeControlOptions: {
							style: google.maps.MapTypeControlStyle.HORIZONTAL_BAR,
							position: google.maps.ControlPosition.TOP_RIGHT,
						},
						zoomControl: true,
						fullscreenControl: false,
						zoomControlOptions: {
							position: google.maps.ControlPosition.TOP_RIGHT,
						},
						styles:[{elementType:"geometry",stylers:[{color:"#f5f5f5"}]},{elementType:"labels.icon",stylers:[{visibility:"off"}]},{elementType:"labels.text.fill",stylers:[{color:"#616161"}]},{elementType:"labels.text.stroke",stylers:[{color:"#f5f5f5"}]},{featureType:"administrative.land_parcel",elementType:"labels.text.fill",stylers:[{color:"#bdbdbd"}]},{featureType:"poi",elementType:"geometry",stylers:[{color:"#eeeeee"}]},{featureType:"poi",elementType:"labels.text.fill",stylers:[{color:"#757575"}]},{featureType:"poi.park",elementType:"geometry",stylers:[{color:"#e5e5e5"}]},{featureType:"poi.park",elementType:"labels.text.fill",stylers:[{color:"#9e9e9e"}]},{featureType:"road",elementType:"geometry",stylers:[{color:"#ffffff"}]},{featureType:"road.arterial",elementType:"labels.text.fill",stylers:[{color:"#757575"}]},{featureType:"road.highway",elementType:"geometry",stylers:[{color:"#dadada"}]},{featureType:"road.highway",elementType:"labels.text.fill",stylers:[{color:"#616161"}]},{featureType:"road.local",elementType:"labels.text.fill",stylers:[{color:"#9e9e9e"}]},{featureType:"transit.line",elementType:"geometry",stylers:[{color:"#e5e5e5"}]},{featureType:"transit.station",elementType:"geometry",stylers:[{color:"#eeeeee"}]},{featureType:"water",elementType:"geometry",stylers:[{color:"#c9c9c9"}]},{featureType:"water",elementType:"labels.text.fill",stylers:[{color:"#9e9e9e"}]}]
					});

					let url_params = new URLSearchParams(window.location.search);

					var xhttp = new XMLHttpRequest();
					xhttp.onreadystatechange = function() {

						if (this.status === 200) {
							let installers = false;
							
							try {
								installers = JSON.parse(xhttp.responseText);
							} catch(error) {
								//SyntaxError: Unexpected end of JSON input
								//Unsure why this is happening
							}

							if(installers) {



								let installersSidebar = document.getElementById("installers-sidebar");

								var i, marker;;

								var prox = 0;

								var markers = []; //array to hold the map pins

								/**
								 Geolocation pin - If using location determined by Geolocation, show an blue circle pin on the map to indicate current location 
								*/
								if (lat && lng) {


									// let marker = new google.maps.Marker({
									// 	position: new google.maps.LatLng(lat, lng), 
									// 	map: LRMap,     
									// 	optimized: false,
									// 	clickable: false,
									// 	icon: {
									// 		url: branches_script_vars.theme_path + '/includes/map/icons/centre.svg',
									// 		scaledSize: new google.maps.Size(25, 25),
									// 	}

									// });


							
									// markers.push(marker);
								}
								
								/**
								 Add pins for the installers
								*/
								for (i = 0; i < installers.length; i++) {



									/**
									 Use custom pin if set, otherwise use default pin 
									*/
									let custom_map_width = parseInt(branches_script_vars.map_pin_width);
									let custom_map_height = parseInt(branches_script_vars.map_pin_height);

									let data = installers[i][0];

									let icon, originalIcon;

									let activeIcon = {
										url: branches_script_vars.theme_path + '/includes/installers/icons/map_icon.svg',
										scaledSize: new google.maps.Size(20, 32)
									};

									mapType = data['map_type'];

									if ( data['type_icon'] && data['map_type'] == 'company') {
										icon = {
											url: data['type_icon'],
											origin: new google.maps.Point(0,0), // origin
											scaledSize: new google.maps.Size(custom_map_width, custom_map_height)
										}
										originalIcon = {
											url: data['type_icon'],
											origin: new google.maps.Point(0,0), // origin
											scaledSize: new google.maps.Size(custom_map_width, custom_map_height)
										}
									} 
									
									else if ( data['industry_icon_colour'] && data['map_type'] == 'group') {
										var template = [
											'<?xml version="1.0"?>',
												'<svg xmlns="http://www.w3.org/2000/svg" width="342" height="500.551" viewBox="0 0 342 500.551">',
													'<path id="Icon_map-map-pin" data-name="Icon map-map-pin" d="M149.067-28.272c-75.331,0-170,100.1-170,173.982,0,73.9,170,311.124,170,311.124S319.045,216.983,319.045,143.081c0-73.883-94.676-171.353-169.978-171.353Z" transform="translate(21.812 43.849)" fill="{{ color }}"/>',
													'<circle id="Ellipse_37" data-name="Ellipse 37" cx="171" cy="171" r="171" transform="translate(0.317 0.133)" fill="{{ color }}"/>',
												'</svg>'
											].join('\n');
										var svg = template.replaceAll('{{ color }}', data['industry_icon_colour']);
										icon = {
											url: 'data:image/svg+xml;charset=UTF-8,' + encodeURIComponent(svg),
											origin: new google.maps.Point(0,0), // origin
											scaledSize: new google.maps.Size(custom_map_width, custom_map_height),
										}
										originalIcon = {
											url: 'data:image/svg+xml;charset=UTF-8,' + encodeURIComponent(svg),
											origin: new google.maps.Point(0,0), // origin
											scaledSize: new google.maps.Size(custom_map_width, custom_map_height),
										}
									} 

									else if ( branches_script_vars.map_pin ) {
										icon = {
											url: branches_script_vars.map_pin,
											origin: new google.maps.Point(0,0), // origin
											scaledSize: new google.maps.Size(custom_map_width, custom_map_height),
										}

										originalIcon = {
											url: branches_script_vars.map_pin,
											origin: new google.maps.Point(0,0), // origin
											scaledSize: new google.maps.Size(custom_map_width, custom_map_height),
										}
									} 

									else {
										icon = {
											url: branches_script_vars.theme_path + '/includes/map/icons/map_icon.svg',
											origin: new google.maps.Point(0,0), // origin
											scaledSize: new google.maps.Size(20, 32)
										}

										originalIcon = {
											url: branches_script_vars.theme_path + '/includes/map/icons/map_icon.svg',
											origin: new google.maps.Point(0,0), // origin
											scaledSize: new google.maps.Size(20, 32)
										};
									}

									/**
										Use custom active pin if set, otherwise use custom pin, otherwise use default pin 
									*/
									if ( branches_script_vars.map_pin_active ) {
										activeIcon = {
											url: branches_script_vars.map_pin_active,
											scaledSize: new google.maps.Size(custom_map_width, custom_map_height)
										}
									}

									let marker = new google.maps.Marker({
										position: new google.maps.LatLng(installers[i][1], installers[i][2]), //get the first and second items (latitude and longitude)
										map: LRMap,
										optimized: false,
										icon: icon
									});

									marker['originalIcon'] = originalIcon;

									markers.push(marker);

									installersSidebar = document.getElementById("installers-sidebar");
									let installersSidebarContent  = document.getElementById("installers-sidebar-content");

									
									google.maps.event.addListener(marker, 'click', (function(marker, i ) {
										return function() {

											installersMap.querySelector('div div[role="region"]').focus();
											installersMap.scrollIntoView();

											if (activeMarker && activeMarker == marker) {

												let installersSidebarContent  = document.getElementById("installers-sidebar-content");
												let installersSidebar  = document.getElementById("installers-sidebar");

												installersSidebar.style.maxHeight = 0;

												let icon = activeMarker.getIcon();
												activeMarker.setIcon(activeMarker['originalIcon']);
												LRMap.setZoom(7.5);
												installersSearch.style.backgroundColor = defaultColour;
												installersSearch.querySelector('.colour-title').classList.remove('!text-rg-text');
												installersSearch.querySelector('.colour-title svg').classList.remove('fill-rg-text');
												let installersMapWrapper = document.getElementsByClassName("installers-map-wrapper")[0];
												installersMapWrapper.classList.remove("show");

												setTimeout(function(){
													installersSidebarContent.innerHTML = '';
													installersSidebar.style.maxHeight = '100vh';
													activeMarker = false;
												}, 200);
											} else {

												let icon = marker.getIcon();
												marker.setIcon({
													url: icon.url,
													scaledSize: new google.maps.Size(25, 35)
												});

												let data = installers[i][0];

												// update the value of activeMarker
												if (activeMarker){

													if (mapType == 'company') {
														activeMarker.setIcon(activeMarker['originalIcon']);
													} else { 
														activeMarker.setIcon(activeMarker['originalIcon']);
														installersSearch.querySelector('.colour-title').classList.remove('!text-rg-text');
														installersSearch.querySelector('.colour-title svg').classList.remove('fill-rg-text');
													}
												}

												activeMarker = marker;

												if (mapType == 'company') {

													installersSidebarContent.innerHTML = `<div class="flex flex-wrap px-7.5 py-10 sm:px-10 relative">
													<button id="close-quicklook" type="button" class="absolute z-10 top-6 right-6">
														<span class="inline-block text-xl rotate-45 pointer-events-none icon-plus ` + (titleShade ? titleShade : `!text-white`) + `"></span>
													</button>
															<h2 class="text-white !mt-0 !text-[26px] !leading-[30px] mb-10 w-full uppercase `+ (titleShade ? titleShade : `rg-primary-text`) + `">
																` + data['name'] + `
															</h2>
															` + (data['phone'] ? `
															<h6 class="text-white font-bold normal-case !mt-0 !mb-1 w-full ` + titleShade + `"><span class="inline-block mr-3 w-[20px] align-top translate-y-[3px] icon-phone text-base rg-primary-text" style="color:` + linkTextColour + ` !important;"></span><a href="tel:` + data['phone'] + `" class="!text-[20px] no-underline ` + (titleShade ? titleShade : `!text-white`) + `">
																	` + data['phone'] + `
																</a>
															</h6>
															` : ``) + (data['email'] ? `
															<h6 class="text-white font-bold normal-case !mt-0 !mb-10 w-full ` + titleShade + `"><span class="inline-block mr-3 w-[20px] align-top translate-y-[3px] icon-envelope text-base rg-primary-text" style="color:` + linkTextColour + ` !important;"></span><a href="mailto:` + data['email'] + `" class="!text-[18px] rg-primary-text no-underline font-normal ` + (titleShade ? titleShade : `!text-white`) + `">
																	` + data['email'] + `
																</a>
															</h6>
															` : ``) + `

															<div class="w-full">
																<span class="inline-block mr-3 w-[20px] align-top translate-y-[2px] icon-location rg-primary-text text-1xl" style="color:` + linkTextColour + `;"></span>
																<p class="text-[23px] leading-[31px] !inline-block align-top !my-0 -translate-y-px font-bold ` + (titleShade ? titleShade : `!text-white`) + `">Location</p>
												
																<p class="!mt-2 mb-6 text-xs !text-gray-400" style="color:` + linkBodyTextColour + ` !important;">` + data['address'] + `</p>
															</div>
															`+ (data['opening_times'] ? `
															<div class="w-full">
																<span class="inline-block mr-3 w-[20px] align-top translate-y-[3px] icon-clock rg-primary-text text-base" style="color:` + linkTextColour + `;"></span>
																<p class="text-[23px] leading-[31px] !inline-block align-top !my-0 -translate-y-px font-bold ` + (titleShade ? titleShade : `!text-white`) + `">Opening Hours</p>
																<ul class="list-none !mt-2">
																` + data['opening_times'].map((item) => {
																	return `<li class="font-bold !text-gray-400" style="color:` + linkBodyTextColour + ` !important;">${item.days}: <span class="text-xs !text-gray-400 font-normal" style="color:` + linkBodyTextColour + ` !important;">${item.times}</span></li>`;
																}).join('') + `
																</ul>
															</div>
															` : ``) + `

														</div><a target="_blank" href="` + data['map'] + `" class="block w-full px-7 md:px-12 py-5 text-left rg-primary-bg !mb-0" style="background-color:` + bottomBgColour + `;">
														<span class="relative block w-full text-sm font-bold tracking-widest text-white uppercase ` + titleShade + `" >` + data['get_directions_text'] + `<span class="absolute right-0 -translate-y-1/2 top-1/2 icon-arrow-right"></span>
														</span>
													</a>
													`;
												} else {
													installersSearch.style.backgroundColor = data['industry_icon_colour'];
													if (data['industry_text_shade'] == true){
														installersSearch.querySelector('.colour-title').classList.add('!text-rg-text');
														installersSearch.querySelector('.colour-title svg').classList.add('fill-rg-text');
													}
													installersSidebarContent.innerHTML = `<div class="flex flex-wrap px-7.5 py-10 sm:px-10 relative">
													<button id="close-quicklook" type="button" class="absolute z-10 top-6 right-6">
														<span class="inline-block text-xl rotate-45 pointer-events-none icon-plus text-white"></span>
													</button>
															<h2 class="!text-white !mt-0 !text-[28px] !leading-[30px] mb-10  w-full uppercase" style="color:` + data['industry_icon_colour']  + ` !important;">
																` + data['name'] + `
															</h2>
															` + (data['phone'] ? `
															<h6 class="!text-white font-bold normal-case !mt-0 !mb-1 w-full"><span class="inline-block mr-3 w-[20px] align-top translate-y-[3px] icon-phone text-base" style="color:` + data['industry_icon_colour']  + `"></span><a href="tel:` + data['phone'] + `" class="!text-[20px] no-underline text-white">
																	` + data['phone'] + `
																</a>
															</h6>
															` : ``) + (data['email'] ? `
															<h6 class="!text-white font-bold normal-case !mt-0 !mb-10 w-full"><span class="inline-block mr-3 w-[20px] align-top translate-y-[3px] icon-envelope text-base" style="color:` + data['industry_icon_colour']  + `"></span><a href="mailto:` + data['email'] + `" class="!text-[18px] no-underline text-white font-normal">
																	` + data['email'] + `
																</a>
															</h6>
															` : ``) + `

															<div class="w-full">
																<span class="inline-block mr-3 w-[20px] align-top translate-y-[2px] icon-location rg-primary-text text-1xl" style="color:` + data['industry_icon_colour']  + ` !important;"></span>
																<p class="!text-white text-[23px] leading-[31px] !inline-block align-top !my-0 -translate-y-px font-bold">Location</p>
												
																<p class="!mt-2 mb-6 text-xs !text-gray-400">` + data['address'] + `</p>
															</div>
															`+ (data['opening_times'] ? `
															<div class="w-full">
																<span class="inline-block mr-3 w-[20px] align-top translate-y-[3px] icon-clock rg-primary-text text-base" style="color:` + data['industry_icon_colour']  + ` !important;"></span>
																<p class="!text-white text-[23px] leading-[31px] !inline-block align-top !my-0 -translate-y-px font-bold">Opening Hours</p>
																<ul class="list-none !mt-2">
																` + data['opening_times'].map((item) => {
																	return `<li class="text-gray-400 font-bold">${item.days}: <span class="text-xs !text-gray-400 font-normal">${item.times}</span></li>`;
																}).join('') + `
																</ul>
															</div>
															` : ``) + `

														</div><a target="_blank" href="` + data['map'] + `" class="block w-full px-7 md:px-12 py-5 text-left rg-primary-bg !mb-0" style="background-color:` + data['industry_icon_colour']  + ` !important;">
														<span class="relative block w-full text-sm font-bold tracking-widest text-white uppercase ` + (data['industry_text_shade'] ? '!text-rg-text' : `!text-white`) + `">` + data['get_directions_text'] + `<span class="absolute right-0 -translate-y-1/2 top-1/2 icon-arrow-right"></span>
														</span>
													</a>
													`;
												}

												installersSidebar.classList.add("show");
												let installersMapWrapper  = document.getElementsByClassName("installers-map-wrapper")[0];
												installersMapWrapper.classList.add("show");
												installersSidebar.setAttribute('tabindex', '0');
												installersSidebar.focus();
												LRMap.setZoom(8);
												var markerCenter = new google.maps.LatLng(marker.getPosition().lat(), marker.getPosition().lng());
												if (window.innerWidth > 1200){
													LRMap.panTo(markerCenter);
												}
											}
										}
									})(marker, i));

								}

								// !!! THIS WILL NOT WORK ON LOCAL DUE TO PHP.INI SETTINGS !!!
								if(url_params.has('origin') ) {

									var closest = false;
									var closestDistance = false;

									for(let i = 0; i < markers.length; i++) {
										//calc distance between origin and each marker & always positive (math.abs)
										var latDistance = Math.abs(lat - markers[i].getPosition().lat());
										var lngDistance = Math.abs(lng - markers[i].getPosition().lng());

										//add distance together to compare to other markers
										var distance = latDistance + lngDistance;


										if (distance > 0) {
											// if marker is closer than previous marker, set as closest
											if (closestDistance === false || distance < closestDistance) {
												closestDistance = distance;
												closest = i;
											}
										}

									}
									//trigger click on closest marker
									new google.maps.event.trigger( markers[closest], 'click' );
									setTimeout(function(){
										LRMap.setZoom(8);
									},1);
								}

							}
						}
					};

					xhttp.open("GET", installersSearch.dataset.endpoint, true);
					xhttp.send('');
				}

				document.addEventListener('click', function (event) {

					// If the clicked element doesn't have the right selector, bail
					if (!event.target.matches('#installers-sidebar-close')) return;
				
					event.target.parentNode.classList.remove('show');
					event.target.parentNode.parentNode.parentNode.classList.remove('show');
				
				}, false);

				document.addEventListener('click', function (event) {

					if (!event.target.matches('#close-quicklook')) return;

					let installersSidebarContent  = document.getElementById("installers-sidebar-content");
					let installersSidebar  = document.getElementById("installers-sidebar");

					installersSidebar.style.maxHeight = 0;

					let icon = activeMarker.getIcon();

					activeMarker.setIcon(activeMarker['originalIcon']);
					LRMap.setZoom(7.5);
					installersSearch.style.backgroundColor = defaultColour;
					installersSearch.querySelector('.colour-title').classList.remove('!text-rg-text');
					installersSearch.querySelector('.colour-title svg').classList.remove('fill-rg-text');
					let installersMapWrapper = document.getElementsByClassName("installers-map-wrapper")[0];
					installersMapWrapper.classList.remove("show");


					setTimeout(function(){
						installersSidebarContent.innerHTML = '';
						installersSidebar.style.maxHeight = '100vh';
					}, 200);
					

				}, false);
			}
		}
	}
});